<app-loader [loader]="loader"></app-loader>
<div class="backdrop" [ngClass]="{ show: backdrop }"></div>

<app-global-navigation></app-global-navigation>
<router-outlet></router-outlet>
